<template>
  <div class="dishes-confirm">
    <selfcheck-calling-modal :visible="isCalling" @cancel="handleCallStaffCancel" />
    <selfcheck-unhandled-error-modal :visible="hasUnhandledError" @backtotop="handleBackToTop" />
    <selfcheck-browser-back-modal
      :visible="isShowingBrowserBackModal"
      @confirm="handleBrowserBackConfirm"
      @cancel="handleBrowserBackCancel"
    />

    <selfcheck-progress :active-index="0" class="selfcheck-progress" />

    <div class="image"><img src="@/assets/images/dishesconfirm0.png" alt="" /></div>
    <ul class="dishes-wrap">
      <li>
        <div class="dish-image dish1"><img src="@/assets/images/dishesconfirm1.png" alt="" /></div>
        <div class="dish-text">{{ $t('selfcheck.sushiPlate') }}</div>
      </li>
      <li>
        <div class="dish-image dish2"><img src="@/assets/images/dishesconfirm2.png" alt="" /></div>
        <div class="dish-text">{{ $t('selfcheck.redPlate') }}</div>
      </li>
      <li>
        <div class="dish-image dish3"><img src="@/assets/images/dishesconfirm3.png" alt="" /></div>
        <div class="dish-text">{{ $t('selfcheck.buckleSeparate') }}</div>
      </li>
    </ul>
    <div class="text">{{ $t('selfcheck.putThePlateInThrowingSlot') }}</div>
    <selfcheck-button-footer class="footer">
      <li>
        <so-button @click="handleCancel">{{ $t('common.cancel') }}</so-button>
      </li>
      <li>
        <so-button variant="red" @click="handleNext">{{ $t('common.putIn') }}</so-button>
      </li>
    </selfcheck-button-footer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import SoButton from '@/components/common/SoButton'
import SelfcheckButtonFooter from '@/components/selfcheck/SelfcheckButtonFooter'
import SelfcheckProgress from '@/components/selfcheck/SelfcheckProgress'
import SelfcheckCallingModal from '@/components/modal/SelfcheckCallingModal'
import SelfcheckUnhandledErrorModal from '@/components/modal/SelfcheckUnhandledErrorModal'
import SelfcheckBrowserBackModal from '@/components/modal/SelfcheckBrowserBackModal'

export default {
  name: 'DishesConfirm',
  components: {
    SoButton,
    SelfcheckButtonFooter,
    SelfcheckProgress,
    SelfcheckCallingModal,
    SelfcheckUnhandledErrorModal,
    SelfcheckBrowserBackModal,
  },
  data() {
    return {
      isCalling: false,
      isCanceled: false,
      isShowingBrowserBackModal: false,
      hasUnhandledError: false,
    }
  },
  computed: {
    ...mapGetters({
      seatStatus: 'seat/getSeatStatus',
      isTable: 'selfcheck/getIsTable',
      isFetching: 'selfcheck/getIsFetching',
      error: 'selfcheck/getError',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  watch: {
    seatStatus() {
      if (this.seatStatus === 4) {
        this.isCalling = true
      }
      if (this.seatStatus === 0) {
        this.isCanceled = true
        this.$router.replace({ name: 'shopMenu' })
      }
    },
  },
  mounted() {
    // mountedの時点で呼出中の場合 = セルフチェック中ユーザーの呼出中のリロード
    if (this.seatStatus === 4) {
      this.isCalling = true
    }
  },
  beforeRouteLeave(to, _from_, next) {
    // 遷移先が次のページなら常に成功
    if (to.name === 'checkConfirm') {
      next()
      return
    }
    // キャンセルされていたら離脱
    if (this.isCanceled) {
      next()
      return
    }
    // それ以外（ブラウザバック）の際はモーダルを表示
    this.showBrowserBackModal()
    next(false)
  },
  methods: {
    ...mapActions({
      createSelfcheckAmount: 'selfcheck/createSelfcheckAmount',
      cancelSelfcheck: 'selfcheck/cancelSelfcheck',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
      setShowingSelfcheckErrorModal: 'modal/setShowingSelfcheckErrorModal',
    }),
    async handleNext() {
      await this.createSelfcheckAmount()

      if (!this.error) {
        this.$router.replace({ name: 'checkConfirm' })
      } else {
        if (this.error.response) {
          if (this.error.response.status === 503) {
            this.isCalling = true
          } else {
            this.hasUnhandledError = true
          }
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
    async cancel(callStaff) {
      await this.cancelSelfcheck({ callStaff })
      if (!this.error) {
        this.isCanceled = true
        this.$router.replace({ name: 'shopMenu' })
      } else {
        if (this.error.response) {
          this.setShowingSelfcheckErrorModal(true)
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
    handleCancel() {
      this.cancel(true)
    },
    handleCallStaffCancel() {
      this.cancel(false)
    },
    handleBackToTop() {
      this.cancel(true)
    },
    async handleBrowserBackConfirm() {
      await this.cancel(true)
      this.hideBrowserBackModal()
    },
    handleBrowserBackCancel() {
      this.hideBrowserBackModal()
    },
    showBrowserBackModal() {
      this.isShowingBrowserBackModal = true
    },
    hideBrowserBackModal() {
      this.isShowingBrowserBackModal = false
    },
  },
  head: {
    title() {
      return {
        inner: this.$t('selfcheck.dishesConfirm'),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.dishes-confirm {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 15px 15px 0;
}
.selfcheck-progress {
  flex-shrink: 0;
}
.image {
  flex-shrink: 0;
  padding: 0 30px;
}
.dishes-wrap {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px auto;
  padding: 0;

  li {
    list-style: none;
    margin-right: 10px;

    &:last-child {
      margin-right: 0;
    }
    .dish-image {
      display: flex;
      align-items: center;
      height: 70px;
      max-width: 100%;

      &.dish1 {
        width: 70px;
      }
      &.dish2 {
        width: 77px;
      }
      &.dish3 {
        width: 130px;
      }
    }
    .dish-text {
      font-size: 12px;
    }
  }
}
.text {
  flex-grow: 1;
  flex-shrink: 0;
  font-size: 20px;
  margin-bottom: 20px;
  white-space: pre-wrap;
}
.footer {
  flex-shrink: 0;
}
</style>
